
<template>
	<div>

		<div class="dropdown-content">

			<div class="dropdown-item">
				<div class="config-title">Ícones</div>

				<div class="config-group icon-size-control">
					<div class="config-label">Tamanhos</div>
					<div class="config-options">
						<span :class="{'selected':preferences.iconSize==47}" @click="setIconSize(47)">menor</span>
						<span :class="{'selected':preferences.iconSize==61}" @click="setIconSize(61)">maior</span>
					</div>
				</div>
				<div class="config-group corners-control">
					<div class="config-label">Formatos</div>
					<div class="config-options">
						<span :class="{'selected':preferences.iconCorners==1}" @click="setIconCorners(1)"><i class="icon-corners1"></i></span>
						<span :class="{'selected':preferences.iconCorners==2}" @click="setIconCorners(2)"><i class="icon-corners2"></i></span>
						<span :class="{'selected':preferences.iconCorners==3}" @click="setIconCorners(3)"><i class="icon-corners3"></i></span>
					</div>
				</div>
			</div>

			<div class="dropdown-item">
				<div class="config-title">Caixas Dinâmicas</div>

				<div class="config-group transparency-control">
					<div class="config-label">Transparência</div>
					<div class="config-options">
						<span :class="{'selected':$store.getters.preferenceTransparency==0}" @click="setTransparency(0)">0%</span>
						<span :class="{'selected':$store.getters.preferenceTransparency==40}" @click="setTransparency(40)">40%</span>
						<span :class="{'selected':$store.getters.preferenceTransparency==100}" @click="setTransparency(100)">100%</span>
					</div>
				</div>

				<div class="config-group text-color-control">
					<div class="config-label">Cor do texto</div>
					<div class="config-options">
						<span class="text-color-option-white" :class="{'selected':$store.getters.preferenceTextColor=='white'}" @click="setTextColor('white')"></span>
						<span class="text-color-option-black" :class="{'selected':$store.getters.preferenceTextColor=='black'}" @click="setTextColor('black')"></span>
						<span class="text-color-option-blue" :class="{'selected':$store.getters.preferenceTextColor=='blue'}" @click="setTextColor('blue')"></span>
					</div>
				</div>

			</div>


			<div class="dropdown-item">
				<div class="config-title">Imagem de fundo</div>

				<div  class="bg-preview">
					<img v-if="$store.getters.preferenceBg" :src="$store.getters.preferenceBg">
					<svg v-else xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 58 58" xml:space="preserve"><g><path d="M57,6H1C0.448,6,0,6.447,0,7v44c0,0.553,0.448,1,1,1h56c0.552,0,1-0.447,1-1V7C58,6.447,57.552,6,57,6z M56,50H2V8h54V50z"/><path d="M16,28.138c3.071,0,5.569-2.498,5.569-5.568C21.569,19.498,19.071,17,16,17s-5.569,2.498-5.569,5.569 C10.431,25.64,12.929,28.138,16,28.138z M16,19c1.968,0,3.569,1.602,3.569,3.569S17.968,26.138,16,26.138s-3.569-1.601-3.569-3.568 S14.032,19,16,19z"/><path d="M7,46c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.391,0.391,1.023,0.391,1.414,0s0.391-1.023,0-1.414 l-4.807-4.807l9.181-10.054l11.261,10.323c0.407,0.373,1.04,0.345,1.413-0.062c0.373-0.407,0.346-1.04-0.062-1.413l-12-11 c-0.196-0.179-0.457-0.268-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325l-9.794,10.727l-4.743-4.743 c-0.374-0.373-0.972-0.392-1.368-0.044L6.339,44.249c-0.415,0.365-0.455,0.997-0.09,1.412C6.447,45.886,6.723,46,7,46z"/></g></svg>
				</div>

				<div class="upload-actions">

					<label class="bg-upload">
						<span v-if="!$store.getters.preferenceBg">Upload</span>
						<svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330" xml:space="preserve"><g><path d="M105.604,105.605L150,61.212v183.786c0,8.284,6.716,15,15,15s15-6.716,15-15V61.213l44.392,44.392 c2.929,2.929,6.768,4.394,10.606,4.394c3.839,0,7.678-1.464,10.607-4.394c5.858-5.858,5.858-15.355,0-21.213l-69.995-69.996 c-0.352-0.351-0.721-0.683-1.104-0.998c-0.166-0.136-0.341-0.254-0.51-0.381c-0.222-0.167-0.439-0.337-0.67-0.492 c-0.207-0.139-0.422-0.259-0.635-0.386c-0.207-0.125-0.41-0.254-0.624-0.369c-0.217-0.116-0.439-0.213-0.661-0.318 c-0.223-0.105-0.441-0.216-0.67-0.311c-0.214-0.088-0.432-0.16-0.649-0.238c-0.244-0.088-0.485-0.182-0.736-0.258 c-0.216-0.065-0.435-0.112-0.652-0.167c-0.256-0.065-0.51-0.137-0.77-0.189c-0.25-0.049-0.503-0.078-0.755-0.115 c-0.231-0.034-0.46-0.077-0.695-0.1c-0.462-0.045-0.925-0.067-1.389-0.07c-0.03,0-0.059-0.004-0.089-0.004 c-0.029,0-0.059,0.004-0.088,0.004c-0.464,0.002-0.928,0.025-1.391,0.07c-0.229,0.023-0.453,0.065-0.68,0.098 c-0.258,0.037-0.516,0.067-0.771,0.118c-0.254,0.05-0.5,0.12-0.749,0.183c-0.226,0.057-0.452,0.107-0.676,0.174 c-0.241,0.073-0.476,0.164-0.712,0.249c-0.225,0.081-0.452,0.155-0.674,0.247c-0.22,0.091-0.43,0.198-0.644,0.299 c-0.23,0.108-0.462,0.211-0.688,0.331c-0.204,0.109-0.396,0.233-0.595,0.351c-0.223,0.132-0.447,0.258-0.664,0.403 c-0.217,0.145-0.42,0.307-0.629,0.462c-0.184,0.137-0.371,0.264-0.549,0.411c-0.365,0.299-0.714,0.616-1.049,0.947 c-0.016,0.016-0.033,0.029-0.05,0.045L84.392,84.391c-5.857,5.858-5.858,15.355,0,21.213 C90.249,111.463,99.747,111.461,105.604,105.605z"/><path d="M315,160c-8.284,0-15,6.716-15,15v115H30V175c0-8.284-6.716-15-15-15s-15,6.716-15,15v130 c0,8.284,6.716,15,15,15h300c8.284,0,15-6.716,15-15V175C330,166.716,323.284,160,315,160z"/></g></svg>
						<input type="file" @change="onFileChange">
					</label>

					<span v-if="$store.getters.preferenceBg" class="bg-rotate" @click="rotateBase64Image90deg($store.getters.preferenceBg,0)">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 453.227 453.227" xml:space="preserve"><g><path d="M139.453,120.747L1.107,259.093L139.453,397.44L277.8,259.093L139.453,120.747z M61.373,259.093l77.973-77.973 l78.08,77.973l-77.973,77.973L61.373,259.093z"/><path d="M395.88,125.44C358.333,88,309.267,69.227,260.093,69.227V0l-90.56,90.56l90.56,90.453v-69.12 c38.187,0,76.48,14.613,105.6,43.733c58.347,58.347,58.347,152.853,0,211.2c-29.12,29.12-67.413,43.733-105.6,43.733 c-20.693,0-41.28-4.373-60.48-12.907l-31.787,31.787c28.587,15.787,60.373,23.787,92.267,23.787 c49.173,0,98.24-18.773,135.787-56.213C470.867,322.027,470.867,200.427,395.88,125.44z"/></g></svg>
					</span>

					<span v-if="$store.getters.preferenceBg" class="bg-remove" @click="excluirBg">
						<svg viewBox="-40 0 427 427.00131" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg>
					</span>

				</div>

			</div>



			<div class="dropdown-item">
				<div class="config-title">Temas Grátis</div>



				<div class="config-group theme-control">
					<div class="config-label">Original</div>
					<div class="config-options">
						<span class="tema-escolha tema13" :class="{selected:preferences.tema=='tema13'}" @click="setTheme('tema13')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Ocean</div>
					<div class="config-options">
						<span class="tema-escolha tema16" :class="{selected:$store.getters.preferenceTema=='tema16'}" @click="setTheme('tema16')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Original +</div>
					<div class="config-options">
						<span class="tema-escolha tema1" :class="{selected:preferences.tema=='tema1'}" @click="setTheme('tema1')"></span>
					</div>
				</div>

				<div class="config-group theme-control">
					<div class="config-label">Green Mood</div>
					<div class="config-options">
						<span class="tema-escolha tema3" :class="{selected:preferences.tema=='tema3'}" @click="setTheme('tema3')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Contrast</div>
					<div class="config-options">
						<span class="tema-escolha tema4" :class="{selected:preferences.tema=='tema4'}" @click="setTheme('tema4')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Fantasia</div>
					<div class="config-options">
						<span class="tema-escolha tema5" :class="{selected:preferences.tema=='tema5'}" @click="setTheme('tema5')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Girly</div>
					<div class="config-options">
						<span class="tema-escolha tema12" :class="{selected:preferences.tema=='tema12'}" @click="setTheme('tema12')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Night</div>
					<div class="config-options">
						<span class="tema-escolha tema2" :class="{selected:preferences.tema=='tema2'}" @click="setTheme('tema2')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Neon</div>
					<div class="config-options">
						<span class="tema-escolha tema6" :class="{selected:preferences.tema=='tema6'}" @click="setTheme('tema6')"></span>
					</div>
				</div>
				<div class="config-group theme-control">
					<div class="config-label">Gamer</div>
					<div class="config-options">
						<span class="tema-escolha tema14" :class="{selected:preferences.tema=='tema14'}" @click="setTheme('tema14')"></span>
					</div>
				</div>
<!-- 				<div class="config-group theme-control">
					<div class="config-label">FLAMENGO</div>
					<div class="config-options">
						<span class="tema-escolha tema15" :class="{selected:preferences.tema=='tema15'}" @click="setTheme('tema15')"></span>
					</div>
				</div>
 -->
			</div>

<!--
			<a class="dropdown-item" href="#" @click.prevent="modalAdicionarSiteInicio">
				Definir como pag.inicial
			</a>
		-->

			<a class="dropdown-item" href="https://forms.gle/dp7TEfqakJ6xV4rs6" target="_blank">
				Dê a sua opinião
			</a>

			<a class="dropdown-item" href="#" @click.prevent="onShare">
				Compartilhar layout completo
			</a>


			<!-- <router-link class="dropdown-item" to="tutorial">Tutorial</router-link> -->
<!--
			<div class="dropdown-item dropdown-item-account" :title="user.email">
				{{ user.email }}
			</div>
			<a class="dropdown-item" href="#" @click.prevent="logout">
				Logout
			</a>
-->
		</div>


	<div v-if="modalShare" class="modal modal-share is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Compartilhar layout completo</p>
				<button class="delete" aria-label="close" @click="closeModalShare"></button>
			</header>
			<section class="modal-card-body">
				<p>Escolha uma opção de compartilhamento</p>
				<p>Link: <span class="share-link" v-if="!isLoading">{{share_link}}</span> <Spinner v-if="isLoading" size="30" /></p>
				<input type="hidden" :value="share_link">
				<div v-if="!isLoading" class="link-share-buttons">

					<a class="link-share-facebook" :href="'https://www.facebook.com/sharer/sharer.php?u='+share_link" target="_blank">
						<span class="icon"><svg viewBox="0 0 24 24"><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" /></svg></span>
						Facebook
					</a>
					<a class="link-share-whatsapp" :href="'https://wa.me/?text=Olá! Clique neste link para adicionar esta categoria ao seu U.R.Links. '+share_link" target="_blank">
						<span class="icon"><svg viewBox="0 0 24 24"><path fill="#000000" d="M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" /></svg></span>
						Whatsapp
					</a>
					<a class="link-share-clipboard" @click="clipboard($event)">
						<i class="icon"><svg viewBox="0 0 24 24"><path fill="#000000" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" /></svg></i>
						&nbsp;<span>Copiar link</span>
					</a>

				</div>

				<!--
				&picture=http%3A%2F%2Fwww.applezein.net%2Fwordpress%2Fwp-content%2Fuploads%2F2015%2F03%2Ffacebook-logo.jpg
				&title=A+nice+question+about+Facebook
				&quote=Does+anyone+know+if+there+have+been+recent+changes+which+could+have+suddenly+stopped+this+from+working%3F
				&description=Apparently%2C+the+accepted+answer+is+not+correct.
			-->

			</section>
		</div>
	</div>



	<div v-if="modalWarning" class="modal modal-warning is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Compartilhar Categoria - <span class="has-text-danger">Atenção</span></p>
				<button class="delete" aria-label="close" @click="closeModalWarning"></button>
			</header>
			<section class="modal-card-body">
				<p>Para compartilhar uma categoria, é preciso ser um usuário registrado. Clique no botão abaixo para efetuar o registro rápido.<br> É grátis! </p>
			</section>
			<div class="modal-card-foot">
				<button class="button is-success" @click.prevent="identifyAnonymous">Registrar</button>
			</div>
		</div>
	</div>





	</div>
</template>

<style>


	.is-mobile .dropdown { display:block; }

	a.dropdown-item:hover, button.dropdown-item:hover {
		background-color:rgba(128,128,128,.3);
	}
	.dropdown-item-account {overflow: hidden; text-overflow: ellipsis; }
	.is-mobile .dropdown-content { max-width: 250px; margin: 0 auto; }

	.theme-control .config-options span { position: relative; height:26px; border-radius:100px;overflow: hidden; }

	.tema-escolha:before{content:''; position: absolute; width:33%; top:0; bottom:0; left:34%;}
	.tema-escolha:after{ content:''; position: absolute; width:33%; top:0; bottom:0; left:67%;}

	.tema-escolha.selected { border:2px solid #fff !important; }

	.tema-escolha.tema1{ background-color:#fff; } .tema-escolha.tema1:before { background-color:#f2f2f2; } .tema-escolha.tema1:after { background-color:#00b3bc; }
	.tema-escolha.tema13{ background-color:#fff; } .tema-escolha.tema13:before { background-color:#f2f2f2; } .tema-escolha.tema13:after { background-color:#f2f2f2; }
	.tema-escolha.tema2{ background-color:#191919; border: 1px solid #ccc; border-width: 0 1px 0 1px; } .tema-escolha.tema2:before { background-color:#333;  border: 1px solid #ccc; border-width: 0 1px 0 1px;} .tema-escolha.tema2:after { background-color:#333; }
	.tema-escolha.tema3{ background-color:#00d5d9; } .tema-escolha.tema3:before { background-color:#f2f2f2; } .tema-escolha.tema3:after { background-color:#00b3bc; }
	.tema-escolha.tema4{ background-color:#333333; } .tema-escolha.tema4:before { background-color:#f2f2f2; } .tema-escolha.tema4:after { background-color:#ffffff; }
	.tema-escolha.tema5{ background-color:#d57dff; } .tema-escolha.tema5:before { background-color:#f2f2f2; } .tema-escolha.tema5:after { background-color:#ffffff; }
	.tema-escolha.tema6{ background-color:#1a1a1a; border: 1px solid #00b3bc;border-width: 0 1px 0 1px; } .tema-escolha.tema6:before { background-color:#1a1a1a;  border: 1px solid #00b3bc; border-width: 0 1px 0 1px; } .tema-escolha.tema6:after { background-color:#1a1a1a;}
	.tema-escolha.tema12{ background-color:#ffb4f5; } .tema-escolha.tema12:before { background-color:#f2f2f2; } .tema-escolha.tema12:after { background-color:#ffffff; }
	.tema-escolha.tema14{ background-color:#273367; } .tema-escolha.tema14:before { background-color:#43549C; } .tema-escolha.tema14:after { background-color:#f2f2f2; }

	.tema-escolha.tema15{ background-color:#000; } .tema-escolha.tema15:before { background-color:#cc0000; } .tema-escolha.tema15:after { background-color:#000; }
	.tema-escolha.tema16{ background-color:#fff; } .tema-escolha.tema16:before { background-color:#f2f2f2; } .tema-escolha.tema16:after { background-color:#f2f2f2; }

</style>


<script>


import firebase from '@/firebase'
import Spinner from '../components/Spinner'


	export default {
		components:{
			Spinner
		},

		computed:{
			user(){
				return this.$store.getters.user;

			},

			userId(){
				return this.$store.getters.userId;

			},
			categories(){
				return this.$store.getters.orderedCategories;
			},
			config(){
				return this.$store.state.config;
			},
			preferences(){
				return this.$store.getters.preferences;
			},
			userName() {
				return this.$store.getters.user.firstName
			},
			share_link(){
				return encodeURI('https://meu.urlinks.com.br/ref/'+this.share_id);
			}

		},
		data() {
			return {
				configActive:false,
				modalWarning:false,
				isLoading:false,
				modalShare:false,
				share_id:null,

				/*
				iconSizes:[47,61],
				tema:'tema13',
				iconSize:61,
				iconCorners:2,
				columnCount:3,
				*/

			}
		},
		methods:{

			clipboard(evt){
				var elm = document.querySelector('.modal-share .modal-card-body input');
				var button = document.querySelector('.link-share-clipboard span');
				elm.setAttribute('type', 'text');
				elm.select();
				try {
					var successful = document.execCommand('copy');
					var msg = successful ? 'successful' : 'unsuccessful';
					var originalTxtButton = button.innerText;
					button.innerText = 'Copiado!';
					setTimeout(()=>{ button.innerText = originalTxtButton; },2000);
				} catch (err) {
					alert('Oops, unable to copy');
				}
				elm.setAttribute('type', 'hidden');
				window.getSelection().removeAllRanges();
			},

			identifyAnonymous(){
				this.$store.dispatch('anonymousRedirectLogin');
			},
			onShare(){
				if(this.$store.getters.user.isAnonymous){
					this.modalWarning = true;
					return;
				}
				this.isLoading = true;
	    	this.modalShare = true;
				let uid = uniqid();
				console.log('this.preferences',this.$store.getters.preferences);
				let profile = {
					uid:uid,
					user_id:this.$store.getters.userId,
					created_at: new Date().getTime(),
					preferences:{
						tema:this.preferences.tema,
						iconSize:this.preferences.iconSize,
						iconCorners:this.preferences.iconCorners,
						columnCount:this.preferences.columnCount,
						hasOpacity:this.preferences.hasOpacity,
						transparency:this.preferences.transparency,
						textColor:this.preferences.textColor,
						bg:this.preferences.bg,
					},
					categories:this.$store.state.categories.categories,
					links:this.$store.state.categories.links,
				}
				if(this.userName) profile.userName = this.userName;
				const db = firebase.firestore();
	      db.collection('shared_dashboards').doc(uid).set(profile).then(()=>{
	      	this.share_id = uid;
	      	this.isLoading = false;
	      }).catch(()=>{
	      	this.isLoading = false;
	      })

			},

			closeModalWarning(){
				this.modalWarning = false;
			},
			closeModalShare(){
				this.modalShare = false;
			},


			setTheme(theme){
				var pristine=true;
				var i;
				let categories = this.categories;
				for(i in categories){
					if(categories[i].theme){
						pristine = false;
					}
				}

				if(!pristine){
					if(!confirm('Esta alteração irá sobrescrever suas configurações já salvas. Deseja atribuir um novo tema mesmo assim?')) return;

					for(i in categories){
						if(categories[i].theme){
							categories[i].theme = null;
							this.$store.dispatch('updateCategory',{category_id:categories[i].id,data:{theme:null}});
							console.log('tema atualizado',categories[i].id);
						}
					}
					//this.$store.dispatch('setCategories',{categories:categories});
				}

				this.$store.dispatch('setTheme',{theme:theme});
				if(theme=='tema15') {
					this.setTransparency(40);
				} else if(theme=='tema16') {
					this.setTransparency(100);
				} else {
					this.setTransparency(0);
				}

				bodyTheme(theme);

			},


			setIconSize(size){
				this.$store.dispatch('setIconSize',{size:size});
			},

			setIconCorners(type){
				this.$store.dispatch('setIconCorners',{type:type});
			},

			setColumnCount(columnCount){
				this.$store.dispatch('setColumnCount',{columnCount:columnCount});
			},
			setOpacity(opacity){
				this.$store.dispatch('setOpacity',{opacity:opacity});
			},
			setTransparency(transparency){
				this.$store.dispatch('setTransparency',{transparency:transparency});
			},
			setTextColor(textColor){
				this.$store.dispatch('setTextColor',{textColor:textColor});
			},
			modalAdicionarSiteInicio(){
				this.$router.push({name:'site-inicio'})
			},
			logout() {
				this.$store.dispatch('userSignOut');
			},

			excluirBg(){
				this.$store.dispatch('setBg',{image:''});
			},
			onFileChange(e){
				console.log('change');
				var files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;
				var file = files[0];
				console.log(file);
				var reader = new FileReader();
				var img = new Image();
				reader.onload = (re) => {

					console.log('reader load');
					img.onload = (ie) => {
						console.log('img load');

						var MAX_WIDTH = 1920;
						var MAX_HEIGHT = 1080;
						var width = img.width;
						var height = img.height;

						if (width > height) {
							if (width > MAX_WIDTH) {
								height *= MAX_WIDTH / width;
								width = MAX_WIDTH;
							}
						} else {
							if (height > MAX_HEIGHT) {
								width *= MAX_HEIGHT / height;
								height = MAX_HEIGHT;
							}
						}

						var canvas = document.createElement('canvas');
						var ctx = canvas.getContext("2d");

						canvas.width = width;
						canvas.height = height;
						ctx.drawImage(img, 0, 0, width, height);
						var dataurl = canvas.toDataURL("image/jpeg",0.8);

						this.$store.dispatch('setBg',{image:dataurl});

					}
					img.src = re.target.result;
				}
				reader.readAsDataURL(file);
			},
			rotateBase64Image90deg(base64Image, isClockwise) {
				var offScreenCanvas = document.createElement('canvas');
				var offScreenCanvasCtx = offScreenCanvas.getContext('2d');

				var img = new Image();
				img.src = base64Image;

				offScreenCanvas.height = img.width;
				offScreenCanvas.width = img.height;

				if (isClockwise) {
					offScreenCanvasCtx.rotate(90 * Math.PI / 180);
					offScreenCanvasCtx.translate(0, -offScreenCanvas.width);
				} else {
					offScreenCanvasCtx.rotate(-90 * Math.PI / 180);
					offScreenCanvasCtx.translate(-offScreenCanvas.height, 0);
				}
				offScreenCanvasCtx.drawImage(img, 0, 0);

				var newbase64 = offScreenCanvas.toDataURL("image/jpeg", 100);
				this.$store.dispatch('setBg',{image:newbase64});
			},



		},
		mounted(){

			document.querySelector('body').addEventListener('click',(e)=>{
				if(this.configActive){
					this.configActive = false;
				}
			});



		}
	}

</script>

